import { Provider } from "jotai";
import ReactDOM from "react-dom/client";

import { App } from "./components/ecosystems/App";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <Provider>
    <App />
  </Provider>,
);
